import { render, staticRenderFns } from "./DialogEmailEditUserGroup.vue?vue&type=template&id=06f3d226&"
import script from "./DialogEmailEditUserGroup.vue?vue&type=script&lang=js&"
export * from "./DialogEmailEditUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports